<template>
  <div class="bannerdiv">
    <el-breadcrumb separator=">" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/backHome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>Banner设置</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <el-form ref="form" :model="queryForm" :inline="true">
      <el-form-item>
        <el-input v-model="queryForm.keyword" placeholder="关键字"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" icon="el-icon-search" circle @click="serch()"></el-button>
      </el-form-item>
    </el-form>-->
    <!-- 表格 -->
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column label="id" type="index" width="300"></el-table-column>
      <!-- <el-table-column
        prop="type"
        label="标识"
        width="300">
      </el-table-column>-->
      <el-table-column prop="name" label="页面标识" width="300"></el-table-column>
      <el-table-column width="400" label="图片">
        <template slot-scope="scope">
          <img class="img" :src="scope.row.images" alt width="200px" />
        </template>
      </el-table-column>
      <el-table-column width="400" label="移动端图片">
        <template slot-scope="scope">
          <img class="img" :src="scope.row.mobile_imgs" alt width="200px" />
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="success" size="small" @click="compile(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 修改弹框 -->
    <el-dialog :visible.sync="childVisible" width="800px" :before-close="handleClose">
      <!-- action="https://api.treegroup-inc.com/admin/dashu/upload" -->
      <el-form label-width="90px" :model="childForm">
        <el-form-item label="首页图片">
          <el-upload
            class="upload-demo"
            action="https://api.treegroup-inc.com/admin/dashu/upload"
            accept="image/png, image/jpeg"
            :headers="headers"
            :show-file-list="false"
            :on-success="upImgSuccess"
            multiple
            :limit="3"
          >
            <el-button icon="el-icon-upload" style="margin-bottom:10px"></el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
          <div class="visibleImg">
            <div
              class="visibleImgdiv"
              v-for="(item,index) in queryForm.image"
              :key="index"
              @mouseover="shade(index)"
              @mouseout="unShade"
            >
              <img :src="item" alt />
              <div v-show="shadeIndex === index" class="img-shutter">
                <div @click="delImg(index)" class="ico">
                  <i class="el-icon-delete" color="#fff"></i>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="移动端图片">
          <el-upload
            class="upload-demo"
            action="https://api.treegroup-inc.com/admin/dashu/upload"
            accept="image/png, image/jpeg"
            :headers="headers"
            :show-file-list="false"
            :on-success="mUpImgSuccess"
            multiple
            :limit="3"
          >
            <el-button icon="el-icon-upload" style="margin-bottom:10px"></el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
          <div class="visibleImg">
            <div
              class="visibleImgdiv"
              v-for="(item,index) in queryForm.mobile_img"
              :key="index"
              @mouseover="mshade(index)"
              @mouseout="munShade"
            >
              <img :src="item" alt />
              <div v-show="mshadeIndex === index" class="img-shutter">
                <div @click="mdelImg(index)" class="ico">
                  <i class="el-icon-delete" color="#fff"></i>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="subChild">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改弹框 -->
    <el-dialog :visible.sync="childVisible2" width="800px" :before-close="handleClose">
      <el-form label-width="90px" :model="childForm">
        <el-form-item label="banner图">
          <el-upload
            class="upload-demo"
            action="https://api.treegroup-inc.com/admin/dashu/upload"
            accept="image/png, image/jpeg"
            :headers="headers"
            :show-file-list="false"
            :on-success="upImgSuccess2"
            multiple
            :limit="3"
          >
            <el-button icon="el-icon-upload" style="margin-bottom:10px"></el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
          <div class="visibleImg">
            <div
              class="visibleImgdiv"
              v-for="(item,index) in queryForm.image"
              :key="index"
              @mouseover="shade(index)"
              @mouseout="unShade"
            >
              <img :src="item" alt />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="移动端图片">
          <el-upload
            class="upload-demo"
            action="https://api.treegroup-inc.com/admin/dashu/upload"
            accept="image/png, image/jpeg"
            :headers="headers"
            :show-file-list="false"
            :on-success="mUpImgSuccess2"
            multiple
            :limit="3"
          >
            <el-button icon="el-icon-upload" style="margin-bottom:10px"></el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
          <div class="visibleImg">
            <div class="visibleImgdiv">
              <img width="60%" :src="queryForm.mobile_img" alt />
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="subChild">确 定</el-button>
      </span>
    </el-dialog>

    <!--分页-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[6]"
      :page-size="6"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>

    <Backfooter></Backfooter>
  </div>
</template>
<script>
import Backfooter from "../../components/dashu/backfooter";
export default {
  components: { Backfooter },
  data() {
    return {
      shadeIndex: -1,
      mshadeIndex: -1,
      pageVal: 1,
      pageSize: 6,
      currentPage: 1,
      id: "",
      total: 0,
      queryForm: {
        id: "",
        type: "",
        name: "",
        image: [],
        mobile_img: []
      },
      headers: {
        Authorization: ""
      },
      tableData: [
        {
          time: "",
          date: "",
          title: "",
          name: "",
          intro: "",
          banner_url: ""
        },
        {
          time: "",
          date: "",
          title: "",
          name: "",
          intro: "",
          banner_url: ""
        }
      ],
      childVisible: false,
      childVisible2: false,
      childForm: {
        title: "",
        intro: "",
        time: "",
        order: 0
      },
      config: {
        serverUrl: `http://test.api.8think.com/ueditor/php/controller.php`,
        toolbars: [
          [
            "fullscreen",
            "source",
            "|",
            "undo",
            "redo",
            "|",
            "bold",
            "italic",
            "underline",
            "fontborder",
            "strikethrough",
            "superscript",
            "subscript",
            "removeformat",
            "formatmatch",
            "autotypeset",
            "blockquote",
            "pasteplain",
            "|",
            "forecolor",
            "backcolor",
            "insertorderedlist",
            "insertunorderedlist",
            "selectall",
            "cleardoc",
            "|",
            "rowspacingtop",
            "rowspacingbottom",
            "lineheight",
            "|",
            "customstyle",
            "paragraph",
            "fontfamily",
            "fontsize",
            "|",
            "directionalityltr",
            "directionalityrtl",
            "indent",
            "|",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "justifyjustify",
            "|",
            "touppercase",
            "tolowercase",
            "|",
            "link",
            "unlink",
            "anchor",
            "|",
            "imagenone",
            "imageleft",
            "imageright",
            "imagecenter",
            "|",
            "insertimage",
            "emotion",
            "scrawl",
            "insertvideo",
            "music",
            "attachment",
            "map",
            "gmap",
            "insertframe",
            "insertcode",
            "webapp",
            "pagebreak",
            "template",
            "background",
            "|",
            "horizontal",
            "date",
            "time",
            "spechars",
            "snapscreen",
            "wordimage",
            "|",
            "inserttable",
            "deletetable",
            "insertparagraphbeforetable",
            "insertrow",
            "deleterow",
            "insertcol",
            "deletecol",
            "mergecells",
            "mergeright",
            "mergedown",
            "splittocells",
            "splittorows",
            "splittocols",
            "charts",
            "|",
            "print",
            "preview",
            "searchreplace",
            "drafts",
            "help"
          ]
        ]
      },
      dataF: "",
      status: "",
      flag: 1,
      status: "",
      imagearray: "",
      arraypp: [
        "http://test.api.chongyi.xiaoxxx.com/uploads/20190507/UquW835T8fLPmSOFaVePlsOXJV9FxOLG2dVjgXum.png",
        "http://test.api.chongyi.xiaoxxx.com/uploads/20190507/UquW835T8fLPmSOFaVePlsOXJV9FxOLG2dVjgXum.png",
        "http://test.api.chongyi.xiaoxxx.com/uploads/20190507/UquW835T8fLPmSOFaVePlsOXJV9FxOLG2dVjgXum.png",
        "http://test.api.chongyi.xiaoxxx.com/uploads/20190507/UquW835T8fLPmSOFaVePlsOXJV9FxOLG2dVjgXum.png",
        "http://test.api.chongyi.xiaoxxx.com/uploads/20190507/UquW835T8fLPmSOFaVePlsOXJV9FxOLG2dVjgXum.png",
        "http://test.api.chongyi.xiaoxxx.com/uploads/20190507/UquW835T8fLPmSOFaVePlsOXJV9FxOLG2dVjgXum.png",
        "http://test.api.chongyi.xiaoxxx.com/uploads/20190507/UquW835T8fLPmSOFaVePlsOXJV9FxOLG2dVjgXum.png"
      ]
    };
  },
  methods: {
    // serch(){
    //    this.$http.post('/admin/dashu/banner/bannerList', {
    //     page: this.pageVal,
    //     pageSize:this.pageSize,
    //     noPaginate:1,
    //     keyword:this.queryForm.keyword
    //   }).then( (res)=> {
    //   //  console.log(res.data.data.list)
    //     var code=res.data.code;
    //     if(code===0){
    //       this.tableData=res.data.data.list
    //        this.total=res.data.data.total
    //     }
    //   }).catch(function (error) {
    //     //  console.log(error);
    //  });
    // },
    // pc鼠标经过显示遮罩
    shade(index) {
      this.shadeIndex = index;
    },
    // pc移出
    unShade() {
      this.shadeIndex = -1;
    },
    // 删除上传图片
    delImg(index) {
      this.queryForm.image.splice(index, 1);
    },
    // pc鼠标经过显示遮罩
    mshade(index) {
      this.mshadeIndex = index;
    },
    // pc移出
    munShade() {
      this.mshadeIndex = -1;
    },
    // 删除上传图片
    mdelImg(index) {
      this.queryForm.mobile_img.splice(index, 1);
    },
    compile(row) {
      this.flag = 0;
      if (row.id === 7) {
        this.childVisible = true;
      } else {
        this.childVisible2 = true;
      }
      this.id = row.id;
      //  console.log(row)
      this.$http
        .post("/admin/dashu/banner/getInfo", { id: this.id })
        .then(res => {
          var code = res.data.code;
          if (code === 0) {
            //  this.getList()
            this.queryForm = res.data.data.lists;
            // this.queryForm.mobileImg = res.data.data.banner.mobile_banner_url
            // console.log(this.queryForm)
          }
        })
        .catch(function(error) {
          //  console.log(error);
        });
    },
    upImgSuccess(res) {
      this.queryForm.image.push(
        "https://api.treegroup-inc.com/" + res.data.url
      );
      // console.log(this.queryForm)
    },
    upImgSuccess2(res) {
      this.queryForm.image = [
        "https://api.treegroup-inc.com/" + res.data.url
      ];
      // console.log(this.queryForm)
    },
    mUpImgSuccess(res) {
      this.queryForm.mobile_img.push(
        "https://api.treegroup-inc.com/" + res.data.url
      );
      // console.log(this.queryForm.mobileImg)
    },
    mUpImgSuccess2(res) {
      this.queryForm.mobile_img = [
        "https://api.treegroup-inc.com/" + res.data.url
      ];
      // console.log(this.queryForm)
    },
    getList() {
      this.$http
        .post("/admin/dashu/banner/bannerList", {
          page: this.pageVal,
          pageSize: this.pageSize,
          noPaginate: 1
        })
        .then(res => {
          var code = res.data.code;
          if (code === 0) {
            this.tableData = res.data.data.lists;
            this.total = res.data.data.lists.length;
            this.imagearray = res.data.data.lists[0].image[0];
            //  console.log(this.tableData)
          }
        })
        .catch(function(error) {
          //  console.log(error);
        });
    },
    // 关闭弹窗
    handleClose() {
      let obj = this.childForm;
      let flag = false;
      // 判断表单是否有填写
      for (var index in obj) {
        if (!obj[index]) {
          // console.log('无')
        } else {
          // console.log('有')
          flag = true;
          break;
        }
      }
      if (flag === true) {
        this.$confirm("关闭后编辑内容将撤销！")
          .then(_ => {
            this.childVisible = false;
            this.childVisible2 = false;
            this.childForm.title = "";
            this.childForm.intro = "";
            this.childForm.time = "";
            this.$store.commit("upUeData", "");
          })
          .catch(_ => {});
      } else {
        this.childVisible = false;
        this.childVisible2 = false;
      }
    },
    // 提交
    subChild() {
      let ueData = this.$store.state.ueData;
      this.$http
        .post("/admin/dashu/banner/update", {
          id: this.queryForm.id,
          image: this.queryForm.image,
          type: this.queryForm.type,
          name: this.queryForm.name,
          mobile_img: this.queryForm.mobile_img
        })
        .then(res => {
          //  console.log(res.data.data)
          var code = res.data.code;
          if (code === 0) {
            this.childVisible = false;
            this.childVisible2 = false;
            this.$message({
              message: "编辑成功",
              center: true
            });
            this.getList();
          } else if (code === -1) {
            this.$message({
              showClose: true,
              message: "请检查是否填写完整",
              type: "error"
            });
          }
        })
        .catch(function(error) {
          //  console.log(error);
        });
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      //  console.log(`当前页: ${val}`);
      this.pageVal = val;
      this.getList();
    }
  },

  created() {
    this.headers.Authorization = window.localStorage.getItem("user_token");
    this.getList();
  },
  mounted() {}
};
</script>
<style scoped>
.el-pagination {
  text-align: center;
  margin-top: 50px;
}

.visibleImg {
  display: flex;
  width: 100%;
  -ms-flex-pack: justify;
  justify-content: flex-start;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.visibleImgdiv {
  width: 30%;
  margin: 1%;
  cursor: pointer;
  background-size: cover;
  -moz-background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: relative;
}
.visibleImgdiv img {
  width: 100%;
  height: 100%;

  object-fit: cover;
  border-radius: 10px;
}
.img-shutter {
  width: 100%;
  height: 100%;
  float: left;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  border-radius: 10px;
  color: white;
}
.ico {
  font-size: 30px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.bannerdiv {
  position: relative;
  padding-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/backPages/banner.vue